import { BookOutlined, ReadOutlined } from '@ant-design/icons';
import { Card, Col, Row, Statistic, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import type { DashboardStats } from '@/types';

const { Text } = Typography;

interface ContentOverviewProps {
	stats: DashboardStats;
}

const ContentOverview = ({ stats }: ContentOverviewProps) => {
	const { t } = useTranslation('components');

	return (
		<Card
			title={
				<span className='font-semibold text-slate-700'>
					{t('dashboard.contentOverview.title')}
				</span>
			}
			className='h-full border border-slate-100 shadow-sm rounded-xl'
			styles={{ body: { padding: '16px' } }}
		>
			<Row gutter={[16, 16]}>
				<Col span={12}>
					<div className='flex items-center gap-3 p-4 bg-slate-50 rounded-lg'>
						<ReadOutlined className='text-2xl text-indigo-500' />
						<div>
							<Text className='text-xs text-slate-500 block'>
								{t('dashboard.contentOverview.breeds')}
							</Text>
							<Statistic value={stats.totalBreeds} valueStyle={{ fontSize: '24px', fontWeight: 'bold' }} />
						</div>
					</div>
				</Col>
				<Col span={12}>
					<div className='flex items-center gap-3 p-4 bg-slate-50 rounded-lg'>
						<BookOutlined className='text-2xl text-emerald-500' />
						<div>
							<Text className='text-xs text-slate-500 block'>
								{t('dashboard.contentOverview.resources')}
							</Text>
							<Statistic value={stats.totalResources} valueStyle={{ fontSize: '24px', fontWeight: 'bold' }} />
						</div>
					</div>
				</Col>
			</Row>
		</Card>
	);
};

export { ContentOverview };
export default ContentOverview;
